export default __webpack_public_path__ + "files/online-d5adaaa697d43d33ffac0e9276651794.png";